import React, { useContext, useLayoutEffect, useMemo } from 'react'
import Control from '../control'
import { firstValid, getObjectValue, isQuoted, isValid, resolveExpression } from '../../utils';
import { useComputed } from './usecomputed';
import { fieldSelectOptions } from '../input/useoptionlist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asBool } from '../input/utils';
import { buttonCell } from '../../board/table/parsecolumns';
import { useSizeStyle } from '../usesizestyle';
import MarkDown from '../../../markdown';
import useStoredMemo from '../../useStoredMemo';
import { OptionListContext } from '.';

const setval = (dispatch, path, type) => {

	const filefn = async (val, files = []) => {
		dispatch({ type: "set-value", path: path, payload: val })
		if (files?.length) {
			let i
			for (i = 0; i < files.length; i++) {
				const file = files[i];
				const filepath = `${path}_files.${i}`
				const reader = new FileReader();

				reader.onload = () => {
					dispatch({
						type: "set-value",
						path: filepath,
						payload: {
							name: file.name,
							type: file.type,
							size: file.size,
							text: reader.result
						}
					})
				}
				reader.onerror = () => { console.warn("Failed to read file!\n\n" + reader.error); }
				reader.readAsText(file);
			}
		}
	}

	switch (type) {
		case "list": return async (payload = {}) => dispatch({ type: "set-value", path: path.concat(".push()"), payload })
		case "file": return filefn
		default: return async (val, _path) => dispatch({ type: "set-value", path: _path || path, payload: val })
	}
}

const useObjectValue = (object, path) => {
	const validPath = isValid(path)
	const [_object] = useStoredMemo(validPath ? object : null)
	const [_path] = useStoredMemo(path)

	return useMemo(() => validPath ? getObjectValue(_object, _path) : undefined, [_object, _path, validPath])
}

const useResolveExpression = (global, local, expression, resolve = true) => {
	const [_global] = useStoredMemo(resolve ? global : null)
	const [_local] = useStoredMemo(resolve ? local : null)
	const [_expression] = useStoredMemo(resolve ? expression : null)

	return useMemo(() => resolve ? resolveExpression(_expression, { global: _global, local: _local }) : undefined, [_expression, _local, _global, resolve])
}

const ListField = ({ fieldData, rowIndex, field, fieldIndex, path, isreadmode, dispatch, toggleReadMode, DisplayBoard, ...rest }) => {
	// const _data = !field.globalpath
	// 	? getObjectValue(fieldData, (field.path || field.name))
	// 	: getObjectValue(rest.pageData, field.path ? `${rest.form_path}.${field.path}` : rest.form_path)

	// const [data] = useStoredMemo(_data)

	const data = firstValid(
		useObjectValue(fieldData, !field.globalpath ? (field.path || field.name) : null),
		useObjectValue(rest.pageData, !field.globalpath ? null : (field.path ? `${rest.form_path}.${field.path}` : rest.form_path))
	)

	// const readmd = useMemo(() => field.readmd && isreadmode && resolveExpression(JSON.stringify(field.readmd), { global: rest.pageData, local: fieldData }), [fieldData, rest.pageData, field.readmd, isreadmode])
	const readmd = useResolveExpression(rest.pageData, fieldData, JSON.stringify(field.readmd), !!(field.readmd && isreadmode))

	const setNewVal = useMemo(() => setval(dispatch, path, field.type), [dispatch, path, field.type]);

	useLayoutEffect(() => {
		if (isValid(data) && toggleReadMode && asBool(data) !== isreadmode) {
			//console.log("section to", isreadmode ? "edit" : "read", "mode");
			toggleReadMode(asBool(data))
		}
	}, [data, toggleReadMode, isreadmode])

	const onClickEdit = () => {
		//console.log("section clicked to", isreadmode ? "edit" : "read", "mode");
		toggleReadMode(!isreadmode)
		if (isValid(data))
			setNewVal(!isreadmode)
	}

	// const fieldValueString = useMemo(() => {
	// 	if (field.value)
	// 		return JSON.stringify(resolveExpression(field.value, { global: rest.pageData, local: fieldData }))
	// 	return field.value;
	// }, [fieldData, rest.pageData, field.value])

	// const fieldValue = useMemo(() => fieldValueString === "undefined" || fieldValueString === undefined ? undefined : JSON.parse(fieldValueString), [fieldValueString])

	const fieldValue = useResolveExpression(rest.pageData, fieldData, field.value, !!field.value)

	const props = {
		...rest,
		...field,
		setNewVal,
		value: fieldValue,
		dispatch,
		parent: fieldData,
		data,
		DisplayBoard
	}

	if (field.type === "number" && fieldData?.currency) props.dataCurrency = fieldData.currency;

	useComputed({ computed: field.computed, data, expression: field.expression, setNewVal: props.setNewVal, pageData: props.pageData, localData: fieldData });

	const storedOptionList = useContext(OptionListContext)[fieldIndex]
	const [option] = useStoredMemo(storedOptionList?.length ? storedOptionList : fieldSelectOptions({ global: props.pageData, local: fieldData })(field))

	// props.title = useMemo(() => {
	// 	if (!props.title || !isQuoted(props.title)) return props.title || undefined

	// 	return resolveExpression(props.title, { global: props.pageData, local: fieldData });
	// }, [props.title, props.pageData, fieldData])

	props.title = firstValid(
		(!props.title || !isQuoted(props.title)) ? props.title : undefined,
		useResolveExpression(props.pageData, fieldData, props.title, isQuoted(props.title))
	)

	if (field.type !== "list") {
		props.dispatch = undefined;
		props.parent = undefined;
		props.pageData = undefined;
		props.scope = rest.pageData?.meta?.scope;
		props.DisplayBoard = undefined;
	}

	const buttonSize = useSizeStyle(field.size || "sm")
	//if (field.type === "button") console.log("form button control", props.value, data, field);
	if (field.hideonform) return null
	else if (field.type === "button") return (
		<div className={`mb-1 form-group form-group-sm col align-self-end align-items-end d-flex flex-row flex-nowrap justify-content-${field.align || 'around'}`} style={{ ...buttonSize, minHeight: '55px' }}>
			{buttonCell(rest.pageData.meta, { ...field, compute: false }, rest.pageData, props.formId)(fieldData, rowIndex, props.value)}
		</div>
	)
	else if (field.type === "section") return (
		<div className={`col-12 ${field.label && "mt-3"} mb-1`} >
			{(field.label) &&
				<h6 className="m-0">{field.label}
					{toggleReadMode && <span onClick={onClickEdit} className="ml-1" style={{ cursor: "pointer" }} title={isreadmode ? "Modo edición" : "Modo lectura"} >
						{isreadmode
							? <FontAwesomeIcon icon={['far', 'edit']} />
							: <FontAwesomeIcon icon={['far', 'eye']} />
						}
					</span>
					}
				</h6>
			}
			<MarkDown children={readmd} DisplayBoard={DisplayBoard} localData={fieldData} close={rest.close} pageData={rest.pageData} meta={rest.pageData?.meta} />
		</div >
	)
	else
		return (
			<Control key={path}
				{...props}
				option={option}
				path={path}
			/>
		)
}


export default ListField;
